export default __webpack_public_path__ + "static/media/connecting_web-sm@1x.fc2bd8c8.jpg";